import "./Banner.css";
import Socials from "./Socials";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";

function Banner() {
  return (
    <div className="banner">
      <div className="banner-image">
        <Link to="/">
          <img
            className="banner-image"
            src="/pomona-park-logo.png"
            alt="Pomona Park Logo"
          />
        </Link>
      </div>
      <div className="banner-navbar">
        <Navbar />
      </div>
      <div className="banner-content">
        <Socials />
      </div>
    </div>
  );
}

export default Banner;
